import Vue from 'src/views/base'
import { Component, Prop } from 'vue-property-decorator'
import template from './bind-success.vue'
import { removeToken, getCompanyToken } from 'common/auth'
import { Store as UserStore } from 'store/modules/user'

@Component({
    name: 'bindSuccess',
    mixins: [template],
    components: {
    }
})
export default class BindSuccess extends Vue {
    @UserStore.getter('userInfo') userInfo

    @Prop({ type: String }) title
    @Prop({ type: String }) tips
    @Prop({ type: Boolean, default: true }) isNeedButton
    @Prop({ type: Boolean, default: false }) isRefresh
    @Prop({ type: String }) to
    @Prop({ type: String }) toText

    second = 3
    redirectText = ''

    created() {

    }

    get hasEmail() {
        return !this.utils.isEmpty(this.userInfo.email)
    }

    get hasMobile() {
        return !this.utils.isEmpty(this.userInfo.mobile)
    }

    mounted() {
        // this.getUserInfo()
        if (!this.isNeedButton) { this.handleAutomicActivation() }
    }

    handleInDashboard() {
        const companyToken = encodeURIComponent(getCompanyToken())
        this.open(`${this.config.api.HOME}/dashboard?companyToken=${companyToken}`)
    }

    handleInSettings() {
        this.goTo('/security/setting')
    }

    handleAutomicActivation() {
        let text = this.toText
        this.redirectText = `${text} (${this.second}S)`
        let timer = setInterval(() => {
            this.second--
            this.redirectText = `${text} (${this.second}S)`
            if (this.second === 0) {
                clearInterval(timer)
                removeToken()
                if (this.isRefresh) {
                    location.href = this.to
                } else {
                    this.goTo(this.to)
                }
            }
        }, 1000)
    }
}



// WEBPACK FOOTER //
// ./src/views/page/main/bind-success/index.js